import {createSelector} from '@ngrx/store';
import {productFaceEntityAdapter as EntityAdapter, ProductFaceState as EntityState} from "./product-face.state";
import {ProductFace as Entity} from './product-face.model';
import {AppState} from "src/app/store/app-store.state";

export const selectState = (state: AppState) => state.productFace;

export const selectAll = createSelector(selectState, EntityAdapter.getSelectors().selectAll);

export const selectById = (entityId: number) =>
  createSelector(selectAll, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const selectTemporaryById = (entityId: number) =>
  createSelector(selectStoreChanges, (entities: Entity[]) => entities.find(p => p.id === entityId));

export const isLoading = createSelector(selectState, (state: EntityState) => state.isLoading);

export const hasErrors = createSelector(selectState, (state: EntityState) => state.error);

export const selectStoreChanges = createSelector(selectState, (state: EntityState) => state.entitiesTemporary);

export const findByCorrelationId = <T>(correlationId: string) => createSelector(
  selectState,
  (state: EntityState) => <T>state.history.find(h => h.correlationId === correlationId)?.payload
);

export const currentEntityId = createSelector(selectState, (state: EntityState) => state.currentEntityId);

export const currentEntity = createSelector(selectState, (state: EntityState) => {
  return state.currentEntityId
    ? state.entities[state.currentEntityId]
    : undefined
});

export const currentTemporaryEntity = createSelector(selectState, (state: EntityState) => {
  return state.currentTemporaryId
    ? state.entitiesTemporary.find(h => h.id === state.currentTemporaryId)
    : undefined
});

export const totalPageable = createSelector(selectState, (state: EntityState) => state.currentPage.totalCount);
export const currentPage = createSelector(selectState, (state: EntityState) => state.currentPage.page);
export const currentSort = createSelector(selectState, (state: EntityState) => state.currentSort);
export const ProductFaceSelectors = {
  selectAll,
  selectById,
  isLoading,
  hasErrors,
  findByCorrelationId,
  currentEntity,
  currentEntityId,
  totalPageable,
  currentPage,
  currentSort,
  selectTemporaryById,
  selectStoreChanges,
  currentTemporaryEntity
};
